<template>
  <router-view />
</template>

<script lang="ts" setup>

</script>

<style>

*{
  font-family: -apple-system,Helvetica Neue,Helvetica,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif!important;
}

</style>
